import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Section nav for the Me area: a row of chips, each its own page
// (/me/reminders, /me/checklist, …). Not sticky — the pages are short now that
// each section is its own route, so it just sits inline under the title. The chip
// for the current route is highlighted and scrolled into view.

// Section ids here MUST match the id/anchor on each section in MePage.js and the
// /me/:section route param.
export const ME_SECTIONS = [
  { id: 'profile', label: 'Profile' },
  { id: 'devices', label: 'Devices' },
  { id: 'preferences', label: 'Preferences' },
  { id: 'health', label: 'Health' },
  { id: 'traits', label: 'About you' },
  // Sits next to "About you" on purpose: that section is what we ask once, this
  // one is how much we ask every day and how much we say back.
  { id: 'insights', label: 'Insights' },
  { id: 'checklist', label: 'Checklist' },
  { id: 'reminders', label: 'Reminders' },
  { id: 'account', label: 'Account' },
];

const chipClass = (on) =>
  `shrink-0 whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${
    on ? 'border-fg bg-fg text-canvas' : 'border-line-strong text-fg-2 hover:text-fg'
  }`;

const MeSectionNav = ({ sections = ME_SECTIONS }) => {
  const navigate = useNavigate();
  const { section } = useParams();
  const active = sections.some((s) => s.id === section) ? section : null;

  // Keep the active chip in view within the horizontal scroller (move scrollLeft
  // directly so we never nudge the page vertically).
  useEffect(() => {
    document.querySelectorAll('.me-nav-scroll').forEach((c) => {
      const chip = c.querySelector(`[data-nav-id="${active}"]`);
      if (chip) c.scrollLeft = chip.offsetLeft - c.clientWidth / 2 + chip.clientWidth / 2;
    });
  }, [active]);

  return (
    <>
      <style>{`.me-nav-scroll{scrollbar-width:none;-ms-overflow-style:none}
        .me-nav-scroll::-webkit-scrollbar{display:none}`}</style>
      <div className="me-nav-scroll flex gap-2 overflow-x-auto">
        {sections.map((s) => (
          <button
            key={s.id}
            type="button"
            data-nav-id={s.id}
            onClick={() => navigate(`/me/${s.id}`)}
            aria-current={active === s.id ? 'page' : undefined}
            className={chipClass(active === s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>
    </>
  );
};

export default MeSectionNav;
